import React, { Component } from 'react'
import { compose } from 'recompose'
import { refElements } from '../../renderer/utils/elementUtils'
import { withElement } from '../../renderer/utils/withElement'
import withReduxElement from './withReduxElement'
import Section from '../../renderer/elements/Section'
import Container from '../../renderer/elements/Container'
import Button from '../../renderer/elements/button/Button'
import Text from '../../renderer/elements/text/Text'
import Columns from '../../renderer/elements/columns/Columns'
import Column from '../../renderer/elements/column/Column'
import Image from '../../renderer/elements/image/Image'
import Div from '../../renderer/elements/Div'
import Divider from '../../renderer/elements/divider/Divider'
import Card from '../../renderer/elements/card/Card'
import CategoryMenus from '../../renderer/elements/categoryMenus/CategoryMenus'
import ImageCarousel from '../../renderer/elements/imageCarousel/ImageCarousel'
import CardGroup from '../../renderer/elements/cardGroup/CardGroup'
import CountDown from '../../renderer/elements/countDown/CountDown'
import ProductCard from '../../renderer/elements/productCard'
import ProductSlider from '../../renderer/elements/productSlider'
import Youtube from '../../renderer/elements/youtube/Youtube'
import TextEditor from '../../renderer/elements/textEditor/TextEditor'

/*eslint-disable */
// input
//  all of element props
//  renderElements
const ReduxElementSwitcher = (
  compose(
    withReduxElement(),
    withElement(),
  )
)(
  class extends Component {

    renderElement = () => {
      const { refElement, ...props } = this.props
      switch (refElement) {
        case refElements.SECTION:
          return <Section {...props} />
        case refElements.CONTAINER:
          return <Container {...props} />
        case refElements.BUTTON:
          return <Button {...props} />
        case refElements.TEXT:
          return <Text {...props} />
        case refElements.COLUMNS:
          return <Columns {...props} />
        case refElements.COLUMN:
          return <Column {...props} />
        case refElements.IMAGE:
          return <Image {...props} />
        case refElements.DIV:
          return <Div {...props} />
        case refElements.DIVIDER:
          return <Divider {...props} />
        case refElements.CARD:
          return <Card {...props} />
        case refElements.CATEGORY_MENUS:
          return <CategoryMenus {...props} />
        case refElements.IMAGE_CAROUSEL:
          return <ImageCarousel {...props} />
        case refElements.CARD_GROUP:
          return <CardGroup {...props} />
        case refElements.COUNT_DOWN:
          return <CountDown {...props} />
        case refElements.PRODUCT_CARD:
          return <ProductCard {...props} />
        case refElements.PRODUCT_SLIDER:
          return <ProductSlider {...props} />
        case refElements.YOUTUBE:
          return <Youtube {...props} />
        case refElements.TEXT_EDITOR:
          return <TextEditor {...props} />
        default:
          return <div>Cannot find Element</div>
      }
    }

    render() {
      return (this.renderElement())
    }
  }
)


export default ReduxElementSwitcher



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/core/ReduxElementSwitcher.js